/* eslint-disable max-classes-per-file */
export class HamtaKvalitetssakradGrotvolymResponseDTO   {

    status: GrotvolymStatus;
    volymer: GrotvolymAtgardDTO[];

    constructor() {
        this.status = undefined;
        this.volymer = undefined;
    }
}

export class GrotvolymAtgardDTO {
    atgardId: number;
    kvalitetssakradGrotvolym: number;
    arManuellGrotvolym: boolean;

    constructor() {
        this.atgardId = undefined;
        this.kvalitetssakradGrotvolym = undefined;
        this.arManuellGrotvolym = undefined;
    }
}

export enum GrotvolymStatus {
    okand = 0,
    ok = 1,
    volymSaknas = 2,
    volymSaknasDelvis = 3,
    arbetsorderSaknas = 4,
    serverError = 5
}
